import MainMap from "components/map/mainMap";
import { RefuelingPoints, Map as SharedMap } from "components/map/shared";
import Loader from "components/shared/loader";
import React from "react";
import { connect } from "react-redux";

class SkippedRefuelingsMap extends MainMap {
    renderBody = () => {
        return (
            <>
                {this.renderRoute()}
                {this.renderRoutePoints()}
                {this.renderRefuelingPoints()}
            </>
        );
    };

    renderRefuelingPoints = () => {
        const { skippedRefuelings } = this.props;
        const { refuelingServiceType } = this.props.data;
        const {
            viewport: { zoom },
            organization,
        } = this.props;
        if (zoom < 2) {
            return null;
        }
        return (
            <RefuelingPoints
                refueling={{ plannedRefuelings: skippedRefuelings }}
                refuelingServiceType={refuelingServiceType}
                organization={organization}
            />
        );
    };

    render() {
        const { viewport, tileUrls } = this.props;
        return (
            <>
                {this.state.isLoading && (
                    <div className="loader-snippet--map-loader">
                        <Loader />
                    </div>
                )}
                <SharedMap
                    ref={(map) => (this.map = map)}
                    mapRef={this.map}
                    viewport={viewport}
                    tileUrls={tileUrls}
                    onViewportChanged={this.handleViewportChange}
                    zoomControl={false}
                    maxZoom={18}
                >
                    {this.renderBody()}
                </SharedMap>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    data: state.map.data,
    tileUrls: state.configs.tileUrls,
});

export default connect(mapStateToProps, {})(SkippedRefuelingsMap);
